var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"uk-card-header uk-text-large uk-text-left",class:_vm.requestClass,attrs:{"title":"click to check"},domProps:{"innerHTML":_vm._s(_vm.requestBr)},on:{"click":function($event){_vm.checked = ! _vm.checked}}})
}
var staticRenderFns = []

export { render, staticRenderFns }